import React from "react";
import AppContainer from "~v2/components/AppContainer/AppContainer";

const ManagementPageContainer = ({ children, title }) => {
  return (
    <AppContainer title={title}>
      <center>
        <div style={{ margin: "10px 0px", width: "90vw" }}>{children}</div>
      </center>
    </AppContainer>
  );
};

export default ManagementPageContainer;
